/** Client-safe STT constants (no process.env). */

export const DEFAULT_SPEECH_REGION = "westeurope";
export const DEFAULT_SPEECH_LANGUAGE = "en-US";
export const SPEECH_TOKEN_TTL_SECONDS = 600;
export const MAX_SPEECH_SESSION_MS = 5 * 60 * 1000;
export const STT_LATENCY_TARGET_MS = 800;
